import CartDrawerDiscount from '../../components/cart-discount/cart-drawer-discount';

export default (item) => {
  return new Promise((resolve, reject) => {
    if (document.documentElement.classList.contains('cart-is-updating')) {
      return;
    }

    document.querySelectorAll('[data-slider-cart-error]').forEach(el => el.classList.remove('active'));
    document.documentElement.classList.add('cart-is-updating');

    const CartDrawerDiscountObj = new CartDrawerDiscount();
    console.log('Updating cart with item:', item);
    $.post({
      url: '/cart/update.js',
      dataType: 'json',
      type: 'post',
      data: { updates: item },
      success: async (cart) => {
        window.theme.cart.data = cart;

        const edit_mode = document.body.classList.contains('edit-cart');
        // We still need to add the new product to the cart so we can't redirect/refresh yet
        if (edit_mode) {
          resolve(true);
          return;
        }

        if (document.querySelector('.template-cart')) {
          window.location.reload(false);
        } else {
          await window.theme.cart.drawerInstance.updateDrawer();
          CartDrawerDiscountObj.init();
        }

        resolve(true);
        return;
      },
      error: async (XHR) => {
        console.log('XHR object:', XHR);
      
        const errorDescription = XHR.responseJSON?.description || XHR.responseText || 'An unknown error occurred. Please try again later.';
        
        // Need to reset the quantity
        if (document.querySelector('.template-cart')) {
          window.location.reload(false);
        } else {
          await window.theme.cart.drawerInstance.updateDrawer(errorDescription);
          CartDrawerDiscountObj.init();
        }
      },
    });
  });
};
